import { administrationRequests } from "api/administrationApi";
import AutoPickSelectInput from "server/components/Fields/AutoPickSelectInput";
import React from "react";
import { ReferenceInput, required } from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";

const StudentsBirthPlace = ({ handleParamChange }) => {
  const { setValue } = useFormContext();
  const structuralUnitId = useWatch({ name: "structuralUnitId" });

  return (
    <>
      <ReferenceInput
        reference={administrationRequests.getStructuralUnitsSelect()}
        source="structuralUnitId"
        filter={{ filterByUser: true }}
      >
        <AutoPickSelectInput
          source="structuralUnitId"
          label="Факултет"
          validate={required()}
          emptyText={false}
          onChange={() => setValue("specialityId", null)}
          onValueChange={v => handleParamChange("structuralUnitId", v)}
        />
      </ReferenceInput>
      {structuralUnitId && (
        <ReferenceInput
          source="specialityId"
          reference={administrationRequests.getSpecialitiesSelect()}
          filter={{ structuralUnitId }}
        >
          <AutoPickSelectInput
            source="specialityId"
            label="Специалност"
            optionText="name"
            optionValue="id"
            validate={[required()]}
            emptyText={false}
            onValueChange={v => handleParamChange("specialityId", v)}
          />
        </ReferenceInput>
      )}
    </>
  );
};

export default StudentsBirthPlace;
